import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import userService from '../../app/services/user.service';
import Loader from '../../UI/loader/loader';
import Graybg from '../../UI/Graybg';
import Card from '../../UI/Card/Card';
import { toast } from 'react-toastify';
import './ViewQuestions.css';
import MyEditor from "../../Components/CkEditor/CkEditor";
import SecBTN from '../../UI/SecBTN';

const ViewQuestions = ({ uploadId, onNext, OnPrevious, GoToTable }) => {

  const navigate = useNavigate();
  const { state } = useLocation();
  const uploadData = state?.uploadData || {};

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingQuestionId, setEditingQuestionId] = useState(null);
  const [editedTags, setEditedTags] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [loadingEditorData, setLoadingEditorData] = useState(false);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [extractId, setExtractId] = useState(null);
  const [searchSerial, setSearchSerial] = useState("");
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewMessage, setReviewMessage] = useState("");
  const [pendingSerials, setPendingSerials] = useState("");
  const [selectedMatchedQid, setSelectedMatchedQid] = useState(null);
  const [qid, setQid] = useState(null);
  const [duplicacyService, setDuplicacyService] = useState(null);




  const [editorData, setEditorData] = useState({
    qid: "",
    q_text: "",
    solution: "",
    answer_type_id: "",
    eng_option: [],
    subjective_answer: "", // ✅ ADD THIS
    p_text: "",
  });

  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;

  // Tag options - using API data
  const [tagOptions, setTagOptions] = useState({
    subjectList: [],
    topicList: [],
    subTopicList: [],
    toughnessList: [],
    quesTypeList: [],
    ansTypeList: []
  });

  useEffect(() => {
    if (!uploadId) {
      toast.error('Upload ID is missing');
      navigate('/questionIngestion');
      return;
    }

    fetchQuestions();
    fetchTagOptions();
  }, [uploadId, currentQuestionIndex]);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const payload = {
        upload_id: uploadId,
        serial_no: currentQuestionIndex + 1
      };

      const response = await userService.getViewQuestionDetails(payload);
      console.log('API Response:', response);

      if (response && response.info === 200) {
        const extractDataId = response.extract_data_id;
        const generatedQuestions = response.generate_question || [];
        const matchedQuestions = response.matched_questionlist || [];
        setExtractId(extractDataId);
        setQid(generatedQuestions.generated_qid);
        setDuplicacyService(generatedQuestions.duplicacy_services)

        // Get the current question from generate_question array
        const currentGeneratedQuestion = generatedQuestions.find(
          q => q.extract_data_id === extractDataId
        );
        console.log(currentGeneratedQuestion);

        if (currentGeneratedQuestion) {
          // Get total questions count
          setTotalQuestions(currentGeneratedQuestion.total_ques || 1);

          // Structure the data for the component
          const questionData = {
            question: {
              qid: currentGeneratedQuestion.generated_qid,
              id: currentGeneratedQuestion.q_id,
              extract_data_id: currentGeneratedQuestion.extract_data_id,
              image_id: currentGeneratedQuestion.image_id,
              total_ques: currentGeneratedQuestion.total_ques,
              // These fields will be loaded from getOverviewData
              q_text: currentGeneratedQuestion.q_text,
              p_text: currentGeneratedQuestion.p_text,
              eng_option: currentGeneratedQuestion.eng_options,
              answer: currentGeneratedQuestion.answer_key,
              solution: currentGeneratedQuestion.solution,

              topic_name: currentGeneratedQuestion.topic_name,
              sub_topic_name: currentGeneratedQuestion.sub_topic_name,
              toughness: currentGeneratedQuestion.toughness,
              type: currentGeneratedQuestion.type,
              anstype: currentGeneratedQuestion.ans_type,
              answer_type: currentGeneratedQuestion.answer_type,
              subject_name: currentGeneratedQuestion.sub_name,
              is_inserted: currentGeneratedQuestion.is_inserted,
              is_reviewed: currentGeneratedQuestion.is_reviewed,
            },
            duplicate_questions: []
          };

          // Load full question details
          if (currentGeneratedQuestion.q_id) {
            await loadQuestionDetails(currentGeneratedQuestion.q_id, questionData);
          }

          // Load matched questions details
          const matchedQuestionsForCurrent = matchedQuestions.filter(
            mq => mq.extract_data_id === extractDataId
          );

          if (matchedQuestionsForCurrent.length > 0) {
            const duplicates = await loadMatchedQuestions(matchedQuestionsForCurrent);
            questionData.duplicate_questions = duplicates;
          }

          setQuestions([questionData]);

          if (matchedQuestionsForCurrent.length > 0) {
            toast.info(`Found ${matchedQuestionsForCurrent.length} matched question(s)`);
          } else {
            toast.success('Question loaded - No duplicates found');
          }
        } else {
          toast.info('No more questions to review');
          setQuestions([]);
        }
      } else {
        toast.error(response?.message || 'Failed to fetch questions');
        setQuestions([]);
      }
    } catch (err) {
      console.error('Error fetching questions:', err);
      toast.error('Something went wrong while fetching questions');
      setQuestions([]);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to load full question details
  const loadQuestionDetails = async (qid, questionData) => {
    console.log("currentQuestion", questions)

    try {
      const engOpts = questions.eng_options;
      questionData.question.q_text = questions.q_text || '';
      questionData.question.solution = questions.solution || '';
      questionData.question.p_text = questions.p_text || '';
      questionData.question.topic_name = questions.topic_name || '';
      questionData.question.sub_topic_name = questions.sub_topic_name || '';
      questionData.question.toughness = questions.toughness || '';
      questionData.question.type = questions.type || '';
      // questionData.question.anstype = overview.anstype |b| '';
      // questionData.question.subject_name = overview.subject_name || '';
      // questionData.question.answer_type_id = overview.answer_type_id;

      // Format options if available
      if (Array.isArray(engOpts) && engOpts.length > 0) {
        const optionsText = engOpts.map(opt => opt.option || '').join('@@@');
        questionData.question.eng_option = optionsText;

        // Get correct answer(s)
        const correctOptions = engOpts
          .map((opt, idx) => opt.is_correct === 1 ? String.fromCharCode(65 + idx) : null)
          .filter(Boolean);
        questionData.question.answer = correctOptions.join(',');
      }
    }
    catch (error) {
      console.error('Error loading question details:', error);
    }
  };

  // Helper function to load matched questions details
  const loadMatchedQuestions = async (matchedList) => {
    const duplicates = [];

    for (const match of matchedList) {
      try {
        const matchedQId = match.matched_q_id;

        const engOpts = match.eng_options;

        const duplicateQuestion = {
          qid: matchedQId,
          matched_q_mapping_id: match.matched_q_mapping_id,
          similarity: `${match.matched_percent}%`,
          source: match.source,
          q_text: match.q_text,
          eng_option: match.eng_options,
          answer: match.answer,
        };

        // Format options
        if (Array.isArray(engOpts) && engOpts.length > 0) {
          const optionsText = engOpts.map(opt => opt.option || '').join('@@@');
          duplicateQuestion.eng_option = optionsText;

          // Get correct answer(s)
          const correctOptions = engOpts
            .map((opt, idx) => opt.is_correct === 1 ? String.fromCharCode(65 + idx) : null)
            .filter(Boolean);
          duplicateQuestion.answer = correctOptions.join(',');
        }

        duplicates.push(duplicateQuestion);
      } catch (error) {
        console.error(`Error loading matched question ${match.matched_q_id}:`, error);
      }
    }

    return duplicates;
  };

  const parseOptions = (optionsString, answerString) => {
    if (!optionsString) return [];

    const opts = optionsString.split("@@@");
    const normalizedAnswer = (answerString || "").trim();
    const answerFlags = normalizedAnswer.includes("@@@")
      ? normalizedAnswer.split("@@@").map((v) => v.trim())
      : [];
    const correctLetters = normalizedAnswer
      ? normalizedAnswer.split(",").map((v) => v.trim())
      : [];

    return opts.map((text, index) => ({
      option_id: "",
      option: text,
      is_correct: answerFlags.length === opts.length
        ? (answerFlags[index] === "1" ? 1 : 0)
        : (correctLetters.includes(String.fromCharCode(65 + index)) ? 1 : 0),
      lang_id: 1
    }));
  };


  const loadQuestionForEditing = async (qid) => {
    setLoadingEditorData(true);

    try {
      const overview = questions[0].question;
      const q = questions[0].question;

      const engOpts = parseOptions(q?.eng_option, q?.answer);
      console.log(overview)


      setEditorData({
        qid,
        q_text: overview?.q_text || "",
        solution: overview?.solution || "",

        answer_type_id: overview?.anstype
          ? String(overview.anstype)
          : "1",

        eng_option: Array.isArray(engOpts) ? engOpts : [],
        answer_type: overview?.answer_type,
        subjective_answer: overview?.answer || "",
        p_text: overview.p_text,
      });

    } catch (error) {
      console.error("Error loading question for editing:", error);
    } finally {
      setLoadingEditorData(false);
    }
  };

  console.log(editorData);
  const isSingleCorrect = editorData.answer_type_id === "1" || editorData.answer_type_id === "";
  const isMultiCorrect = editorData.answer_type_id === "2";
  const hasMultipleCorrectAnswers = (editorData.eng_option || []).filter((o) => o.is_correct === 1).length > 1;
  const allowMultipleCorrectSelection = isMultiCorrect || hasMultipleCorrectAnswers;

  const isIntegerOrSubjective = editorData.answer_type_id === "3" || editorData.answer_type_id === "4";
  console.log(isIntegerOrSubjective)


  const addNewOptionRow = () => {
    setEditorData((prev) => ({
      ...prev,
      eng_option: [
        ...prev.eng_option,
        { qid: prev.qid, option_id: "", option: "", is_correct: 0, lang_id: 1 },
      ],
    }));
  };

  const removeOptionRow = (index) => {
    setEditorData((prev) => {
      const eng = [...prev.eng_option];
      eng.splice(index, 1);
      return { ...prev, eng_option: eng };
    });
  };

  const setOptionCorrect = (index, checked) => {
    setEditorData((prev) => {
      const eng = prev.eng_option.map((o, i) => {
        if (i === index) return { ...o, is_correct: checked ? 1 : 0 };
        if (!allowMultipleCorrectSelection) return { ...o, is_correct: 0 };
        return o;
      });
      return { ...prev, eng_option: eng };
    });
  };

  const saveQuestionText = async () => {
    if (!editorData.qid) return;
    if (!user_id) {
      toast.error("User not found in localStorage");
      return;
    }
    await userService.createQuesText({
      qid: editorData.qid,
      q_text: editorData.q_text,
      inserted_by: user_id,
    });
  };

  const saveSolution = async () => {
    if (!editorData.qid) return;
    if (!user_id) {
      toast.error("User not found in localStorage");
      return;
    }
    await userService.createSolution({
      qid: editorData.qid,
      sol_text: editorData.sol_text,
      language: 1,
      inserted_by: user_id,
    });
  };

  const saveOptions = async () => {
    if (!editorData.qid) return;
    if (!user_id) {
      toast.error("User not found in localStorage");
      return;
    }

    if (!(isSingleCorrect || isMultiCorrect)) return;

    const body = {
      options: editorData.eng_option.map((o) => ({
        qid: editorData.qid,
        opt_id: o.option_id,
        is_correct: o.is_correct,
        language: o.lang_id,
        opt_txt: o.option,
        answer_type: editorData.answer_type_id,
        inserted_by: user_id,
      })),
    };
    await userService.createOptions(body);
  };

  // Save edits for the current question (PDF question review)
  const saveAllEdits = async () => {


    const currentQuestionData = questions[0];
    const currentQuestion = currentQuestionData?.question;

    if (!currentQuestion) {
      toast.error("No question data found to save");
      return;
    }

    setLoading(true);
    try {
      // Build eng_options string (options separated by '@@@')
      const engOptionsString = (editorData.eng_option || [])
        .map((o) => o.option || "")
        .join("@@@");

      // Build answer_key string (0/1 flags separated by '@@@')
      const answerKeyString = (editorData.eng_option || [])
        .map((o) => (o.is_correct === 1 ? "1" : "0"))
        .join("@@@");

      const payload = {
        extract_data_id: extractId,
        upload_id: Number(uploadId),
        img_id: currentQuestion.image_id,
        q_text: editorData.q_text || currentQuestion.q_text || "",
        // solution: editorData.solution,
        p_text: editorData.p_text || "",
        m_text: "",
        // eng_options: engOptionsString,
        subject: editedTags.sub_id ? Number(editedTags.sub_id) : 0,
        topic: editedTags.topic_id ? Number(editedTags.topic_id) : 0,
        sub_topic: editedTags.sub_topic_id ? Number(editedTags.sub_topic_id) : 0,
        q_type: editedTags.qtype_id ? Number(editedTags.qtype_id) : 0,
        ans_type: editedTags.anstype_id
          ? Number(editedTags.anstype_id)
          : editorData.answer_type_id
            ? Number(editorData.answer_type_id)
            : 0,
        answer_key: answerKeyString,
        toughness_id: editedTags.toughness_id,
        is_edit: 1,
      };

      await userService.saveQuestionData(payload).
        then(res => {
          console.log(res)
          setExtractId(res.latest_question_id)
        })

      toast.success("Question updated successfully");

      // Refresh editor state and question list
      await refreshCurrentQuestion();
    } catch (error) {
      console.error("Error saving edits:", error.response.data.message);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  // API functions for fetching tag options - same as QuestionList.js
  const getSubjectList = () => {
    setLoading(true);
    userService.getSubjectList()
      .then(res => {
        setTagOptions(prev => {
          return { ...prev, subjectList: res.data.data };
        });
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };

  const getTopicList = (subId) => {
    if (!subId) {
      setTagOptions(prev => {
        return { ...prev, topicList: [], subTopicList: [] };
      });
      return Promise.resolve();
    }
    setLoading(true);
    return userService.getTopicListBySid(subId)
      .then(res => {
        const topiclist = res.data.data.filter(topic => topic.status == 1 && topic.topic_sequence !== null);
        setTagOptions(prev => {
          return { ...prev, topicList: topiclist, subTopicList: [] };
        });
        setLoading(false);
        return topiclist;
      })
      .catch(err => {
        console.log(err);
        setTagOptions(prev => {
          return { ...prev, topicList: [], subTopicList: [] };
        });
        setLoading(false);
        return [];
      });
  };

  const getSubTopicList = (tid) => {
    if (!tid) {
      setTagOptions(prev => {
        return { ...prev, subTopicList: [] };
      });
      return Promise.resolve();
    }
    setLoading(true);
    return userService.getSubTopicByTid(tid)
      .then(res => {
        const subtopiclist = res.data.data.filter(subtopic => subtopic.status == 1 && subtopic.sub_topic_sequence !== null);
        setTagOptions(prev => {
          return { ...prev, subTopicList: subtopiclist };
        });
        setLoading(false);
        return subtopiclist;
      })
      .catch(err => {
        console.log(err);
        setTagOptions(prev => {
          return { ...prev, subTopicList: [] };
        });
        setLoading(false);
        return [];
      });
  };

  const getQuesTypeList = () => {
    setLoading(true);
    userService
      .getQuesType()
      .then((res) => {
        setTagOptions((prev) => {
          return { ...prev, quesTypeList: res.data.data };
        });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getAnsTypeList = () => {
    setLoading(true);
    userService
      .getAnsType()
      .then((res) => {
        setTagOptions((prev) => {
          return { ...prev, ansTypeList: res.data.data };
        });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getToughnessList = () => {
    setLoading(true);
    userService.getToughness()
      .then(res => {
        setTagOptions(prev => {
          return { ...prev, toughnessList: res.data.data };
        });
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };

  const fetchTagOptions = async () => {
    try {
      // Fetch all initial lists
      getSubjectList();
      getToughnessList();
      getQuesTypeList();
      getAnsTypeList();
    } catch (error) {
      console.error('Error fetching tag options:', error);
    }
  };

  const handleEditClick = async (question) => {
    const qid = question.qid || question.id;
    setEditingQuestionId(qid);
    console.log(question);

    // Find IDs from names if available
    const findSubjectId = (name) => {
      if (!name) return '';
      const subject = tagOptions.subjectList.find(s => s.sub_name === name);
      return subject ? subject.sub_id : '';
    };

    const findTopicId = (name) => {
      if (!name) return '';
      const topic = tagOptions.topicList.find(t => t.topic_name === name);
      return topic ? topic.topic_id : '';
    };

    const findSubTopicId = (name) => {
      if (!name) return '';
      const subTopic = tagOptions.subTopicList.find(st => st.Sub_topic_name === name);
      return subTopic ? subTopic.sub_topic_id : '';
    };

    const findToughnessId = (name) => {
      if (!name) return '';
      const toughness = tagOptions.toughnessList.find(
        t => t.toughness === name
      );
      return toughness ? toughness.toughness_id : '';
    };


    const findQuesTypeId = (name) => {
      if (!name) return '';
      const quesType = tagOptions.quesTypeList.find(qt => qt.type === name);
      return quesType ? quesType.type_id : '';
    };

    const findAnsTypeId = (name) => {
      if (!name) return '';
      const ansType = tagOptions.ansTypeList.find(at => at.answer_type === name);
      return ansType ? ansType.answer_id : '';
    };

    const subId = findSubjectId(question.subject_name);
    const initialSubId = question.sub_id || findSubjectId(question.subject_name);
    const initialTopicId = question.topic_id || '';
    const initialSubTopicId = question.sub_topic_id || '';

    let resolvedTopicList = [];
    let resolvedSubTopicList = [];

    if (initialSubId) {
      resolvedTopicList = await getTopicList(initialSubId);
    }

    const topicId = initialTopicId || (
      resolvedTopicList.find(t => t.topic_name === question.topic_name)?.topic_id || findTopicId(question.topic_name)
    );

    if (topicId) {
      resolvedSubTopicList = await getSubTopicList(topicId);
    }

    const subTopicId = initialSubTopicId || (
      resolvedSubTopicList.find(st => st.Sub_topic_name === question.sub_topic_name)?.sub_topic_id || findSubTopicId(question.sub_topic_name)
    );
    const toughnessId = findToughnessId(question.toughness);
    const qtypeId = findQuesTypeId(question.type);
    const anstypeId = findAnsTypeId(question.answer_type);
    // const subId = initialSubId;

    // Set initial tags
    setEditedTags({
      sub_id: subId || question.sub_id || '',
      topic_id: topicId || question.topic_id || '',
      sub_topic_id: subTopicId || question.sub_topic_id || '',
      toughness_id: toughnessId || '',
      qtype_id: qtypeId || question.qtype_id || question.type_id || '',
      anstype_id: anstypeId || question.anstype_id || question.answer_id || '',
      // Keep names for display purposes
      topic_name: question.topic_name || '',
      sub_topic_name: question.sub_topic_name || '',
      type: question.type || '',
      anstype: question.anstype || '',
      subject_name: question.subject_name || ''
    });

    loadQuestionForEditing(qid);
  };

  const submitSolution = async () => {
    const q = questions[0]?.question;
    if (!q) return;

    try {
      setLoading(true);

      const payload = {
        extract_data_id: extractId,
        upload_id: Number(uploadId),
        img_id: q.image_id,
        solution: editorData.solution,
      };

      await userService.editQuestionSolution(payload);
      toast.success("Solution updated successfully");

      await refreshCurrentQuestion();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update solution");
    } finally {
      setLoading(false);
    }
  };

  const submitOptions = async () => {
    const q = questions[0]?.question;
    if (!q) return;

    try {
      setLoading(true);

      let engOptionsString = "";
      let answerKeyString = "";

      // ✅ MCQ (1 / 2)
      if (isSingleCorrect || isMultiCorrect) {
        engOptionsString = editorData.eng_option
          .map((o) => o.option || "")
          .join("@@@");

        answerKeyString = editorData.eng_option
          .map((o) => (o.is_correct === 1 ? "1" : "0"))
          .join("@@@");
      }

      // ✅ Integer / Subjective (3 / 4)
      if (isIntegerOrSubjective) {
        if (!editorData.subjective_answer) {
          toast.error("Answer is required");
          return;
        }

        engOptionsString = ""; // 🔥 IMPORTANT
        answerKeyString = editorData.subjective_answer; // 🔥 ACTUAL ANSWER
      }

      const payload = {
        extract_data_id: extractId,
        upload_id: Number(uploadId),
        img_id: q.image_id,
        eng_options: engOptionsString,
        answer_key: answerKeyString,
      };

      await userService.editQuestionOptions(payload);

      toast.success("Answer updated successfully");
      await refreshCurrentQuestion();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update answer");
    } finally {
      setLoading(false);
    }
  };


  const handleSearchQuestion = () => {
    const serial = Number(searchSerial);

    if (!serial || serial < 1) {
      toast.error("Enter a valid question number");
      return;
    }

    if (serial > totalQuestions) {
      toast.error(`Maximum question number is ${totalQuestions}`);
      return;
    }

    // Set index (API will auto call because of useEffect dependency)
    setCurrentQuestionIndex(serial - 1);

    // Exit edit mode if active
    handleCancelEdit();
  };





  const handleCancelEdit = () => {
    setEditingQuestionId(null);
    setEditedTags({});
    setEditorData({
      qid: "",
      q_text: "",
      sol_text: "",
      answer_type_id: "",
      eng_option: [],
      subjective_answer: "",
      p_text: "",
    });
  };

  const handleTagChange = (field, value) => {
    // Handle cascading dropdowns
    if (field === 'subject_id' || field === 'sub_id') {
      // When subject changes, fetch topics and reset topic/subtopic
      getTopicList(value);
      setEditedTags(prev => ({
        ...prev,
        [field]: value,
        topic_id: '',
        sub_topic_id: ''
      }));
    } else if (field === 'topic_id') {
      // When topic changes, fetch subtopics and reset subtopic
      getSubTopicList(value);
      setEditedTags(prev => ({
        ...prev,
        [field]: value,
        sub_topic_id: ''
      }));
    } else {
      // For other fields, just update the value
      setEditedTags(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const handleKeep = async (question) => {
    console.log(question)
    try {
      setLoading(true);
      const payload = {
        img_id: question.image_id,
        extract_data_id: question.extract_data_id,
        is_keep: "1"
      }
      // API call to mark question as unique/keep
      await userService.KeepQuestion(payload);

      toast.success('Question marked as unique');
      setLoading(false);
      handleNext();
    } catch (error) {
      console.error('Error keeping question:');
      toast.error(error.response.data.message);
    }
    finally {
      setLoading(false);
    }
  };

  const handleDiscard = async (question) => {

    if (!selectedMatchedQid) {
      toast.error("Please select a matched question first");
      return;
    }

    try {

      const payload = {
        img_id: question.image_id,
        extract_data_id: question.extract_data_id,
        is_keep: "0",
        matched_q_id: selectedMatchedQid
      };

      await userService.KeepQuestion(payload);

      toast.success("Question discarded successfully");

      setSelectedMatchedQid(null);

      handleNext();

    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };




  const handleNext = () => {
    if (currentQuestionIndex < totalQuestions - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
      handleCancelEdit();
    } else {
      toast.info('You have reviewed all questions');
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(prev => prev - 1);
      handleCancelEdit();
    }
  };

  const refreshCurrentQuestion = async () => {
    await fetchQuestions();
    setEditingQuestionId(null); // exit edit mode (optional)
  };

  const handleFinalSubmit = async () => {
    try {
      setLoading(true);

      const response = await userService.getFinalSavedQuestionList(uploadId);

      if (response?.info !== 200) {
        toast.error(response?.message || "Request failed");
        return;
      }

      // 🔴 If review pending
      if (response?.error === 1) {
        setReviewMessage(response?.message);
        setPendingSerials(response?.review_pending_questions);
        setShowReviewModal(true);
        return;
      }

      // 🟢 If success
      if (response?.error === 0) {
        toast.success("Final submission completed successfully");
        onNext?.();
      }

    } catch (error) {
      console.error(error);
      toast.error("Something went wrong during final submission");
    } finally {
      setLoading(false);
    }
  };

  const handleGoToPendingQuestion = () => {
    if (!pendingSerials) return;

    const firstSerial = Number(pendingSerials.split(",")[0]);

    if (!firstSerial) return;

    // Close modal
    setShowReviewModal(false);

    // Cancel edit if active
    handleCancelEdit();

    // Jump to first pending question
    setCurrentQuestionIndex(firstSerial - 1);
  };





  const currentQuestionData = questions[0];
  const currentQuestion = currentQuestionData?.question;
  console.log(currentQuestion);
  const duplicateQuestions = currentQuestionData?.duplicate_questions || [];
  console.log(duplicateQuestions);
  const currentQuestionId = currentQuestion ? (currentQuestion.qid || currentQuestion.id) : null;
  const isEditing = editingQuestionId === currentQuestionId;

  return (
    <Graybg>
      {loading && <Loader />}
      <div className="view-questions-container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h4>Questions & Tags Review</h4>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/questionIngestion">Question Ingestion</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Review Questions</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className="d-flex gap-2">
            <button
              className="btn btn-success"
              onClick={handleFinalSubmit}
            >
              Final Submit
            </button>

            <SecBTN
              className="btn sec-btn"
              onClick={GoToTable}
            >
              Back to List
            </SecBTN>
          </div>

        </div>

        {!currentQuestion && !loading ? (
          <Card>
            <div className="text-center p-4">
              <p className="text-muted">No questions found for review.</p>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-success"
                  onClick={handleFinalSubmit}
                >
                  Final Submit
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={GoToTable}
                >
                  Back to List
                </button>
              </div>

            </div>
          </Card>
        ) : currentQuestion ? (
          <div className="question-review-layout">
            {/* Navigation */}

            <div className="question-navigation mb-3 d-flex justify-content-between align-items-center flex-wrap">

              {/* Left Side - Prev / Info / Next */}
              <div className="d-flex align-items-center gap-3">
                <button
                  className="btn btn-outline-primary"
                  onClick={handlePrevious}
                  disabled={currentQuestionIndex === 0}
                >
                  <i className="fa fa-chevron-left"></i> Previous
                </button>

                <span>
                  Question {currentQuestionIndex + 1} of {totalQuestions}
                </span>

                <button
                  className="btn btn-outline-primary"
                  onClick={handleNext}
                  disabled={currentQuestionIndex >= totalQuestions - 1}
                >
                  Next <i className="fa fa-chevron-right"></i>
                </button>
              </div>

              {/* Right Side - Search */}
              <div className="d-flex align-items-center gap-2">
                <input
                  type="number"
                  className="form-control"
                  style={{ width: "150px" }}
                  placeholder="Go to question"
                  value={searchSerial}
                  onChange={(e) => setSearchSerial(e.target.value)}
                />
                <button
                  className="btn btn-primary"
                  onClick={handleSearchQuestion}
                >
                  Go
                </button>
              </div>

            </div>


            <div className="row">
              {/* Main Question Section - Left Side */}
              <div className={isEditing ? "col-lg-12" : "col-lg-7"}>

                <Card className="main-question-card">
                  <div className="question-header">
                    <h5>Current Question</h5>
                    {currentQuestion.qid && (
                      <span className="badge badge-info">QID: {currentQuestion.qid}</span>
                    )}
                  </div>

                  {/* Tags Section */}
                  <div className="tags-section">
                    {isEditing ? (
                      <div className="row">
                        <div className="col-md-4 mb-2">
                          <label className="small">Subject:</label>
                          <select
                            className="form-control form-control-sm"
                            value={editedTags.sub_id || editedTags.subject_id || ''}
                            onChange={(e) => handleTagChange('sub_id', e.target.value)}
                          >
                            <option value="">Select Subject</option>
                            {tagOptions.subjectList.map(subject => (
                              <option key={subject.sub_id} value={subject.sub_id}>{subject.sub_name}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="small">Topic:</label>
                          <select
                            className="form-control form-control-sm"
                            value={editedTags.topic_id || ''}
                            onChange={(e) => handleTagChange('topic_id', e.target.value)}
                            disabled={!editedTags.sub_id && !editedTags.subject_id}
                          >
                            <option value="">Select Topic</option>
                            {tagOptions.topicList.map(topic => (
                              <option key={topic.topic_id} value={topic.topic_id}>{topic.topic_name}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="small">Sub-topic:</label>
                          <select
                            className="form-control form-control-sm"
                            value={editedTags.sub_topic_id || ''}
                            onChange={(e) => handleTagChange('sub_topic_id', e.target.value)}
                            disabled={!editedTags.topic_id}
                          >
                            <option value="">Select Sub-topic</option>
                            {tagOptions.subTopicList.map(subTopic => (
                              <option key={subTopic.sub_topic_id} value={subTopic.sub_topic_id}>{subTopic.Sub_topic_name}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="small">Toughness:</label>
                          <select
                            className="form-control form-control-sm"
                            value={editedTags.toughness_id || ''}
                            onChange={(e) => handleTagChange('toughness_id', e.target.value)}
                          >
                            <option value="">Select Toughness</option>
                            {tagOptions.toughnessList.map(toughness => (
                              <option key={toughness.toughness_id} value={toughness.toughness_id}>{toughness.toughness}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="small">Question Type:</label>
                          <select
                            className="form-control form-control-sm"
                            value={editedTags.qtype_id || editedTags.type_id || ''}
                            onChange={(e) => handleTagChange('qtype_id', e.target.value)}
                          >
                            <option value="">Select Question Type</option>
                            {tagOptions.quesTypeList.map(quesType => (
                              <option key={quesType.type_id} value={quesType.type_id}>{quesType.type}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="small">Answer Type:</label>
                          <select
                            className="form-control form-control-sm"
                            value={editedTags.anstype_id || editedTags.answer_id || ''}
                            onChange={(e) => handleTagChange('anstype_id', e.target.value)}
                          >
                            <option value="">Select Answer Type</option>
                            {tagOptions.ansTypeList.map(ansType => (
                              <option key={ansType.answer_id} value={ansType.answer_id}>{ansType.answer_type}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    ) : (
                      <div className="tags-display">
                        {(
                          <span className="badge badge-secondary mr-2">
                            Topic: {currentQuestion.topic_name}
                          </span>
                        )}
                        {(
                          <span className="badge badge-secondary mr-2">
                            Sub-topic: {currentQuestion.sub_topic_name}
                          </span>
                        )}
                        {(
                          <span className="badge badge-secondary mr-2">
                            Toughness: {currentQuestion.toughness}
                          </span>
                        )}
                        {(
                          <span className="badge badge-secondary mr-2">
                            Type: {currentQuestion.type}
                          </span>
                        )}
                        {(
                          <span className="badge badge-secondary mr-2">
                            Answer Type: {currentQuestion.answer_type}
                          </span>
                        )}
                        {(
                          <span className="badge badge-secondary mr-2">
                            Subject: {currentQuestion.subject_name}
                          </span>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Question Content */}
                  {!isEditing && (
                    <div className="question-content-section">
                      {currentQuestion.is_reviewed === 1 && (
                        <>

                          {currentQuestion.is_inserted == 1 && (
                            <div className="alert alert-success">
                              This question is already generated. QID is <strong>{currentQuestion.qid}</strong>
                            </div>
                          )}

                          {currentQuestion.is_inserted === 0 && (
                            <div className="alert alert-danger">
                              This question has been discarded.
                            </div>
                          )}
                        </>
                      )}

                      {currentQuestion.p_text && (
                        <div className="">
                          <strong>Paragraph:</strong>
                          <div
                            className="content-box"
                            dangerouslySetInnerHTML={{ __html: currentQuestion.p_text }}
                          />
                        </div>
                      )}

                      <div className="mb-3">
                        <strong>Question:</strong>
                        <div
                          className="content-box"
                          dangerouslySetInnerHTML={{ __html: currentQuestion.q_text }}
                        />
                      </div>

                      {currentQuestion.eng_option && (
                        <div className="mb-3">
                          <strong>Options:</strong>
                          <ol className="options-list">
                            {currentQuestion.eng_option.split("@@@").map((option, i) => (
                              <li key={i}>
                                <div dangerouslySetInnerHTML={{ __html: option }} />
                              </li>
                            ))}
                          </ol>
                        </div>
                      )}

                      {currentQuestion.answer && (
                        <div className="mb-3">
                          <strong>Answer:</strong>
                          <span className="badge badge-success ml-2">
                            {
                              currentQuestion.answer.includes("@@@")
                                ? currentQuestion.answer
                                  .split("@@@")
                                  .map((v, i) => (v === "1" ? ["A", "B", "C", "D"][i] : null))
                                  .filter(Boolean)
                                  .join(", ")
                                : currentQuestion.answer
                            }
                          </span>
                        </div>
                      )}


                      {currentQuestion.solution && (
                        <div className="mb-3">
                          <strong>Solution:</strong>
                          <div
                            className="content-box"
                            dangerouslySetInnerHTML={{ __html: currentQuestion.solution }}
                          />
                        </div>
                      )}
                    </div>
                  )}

                  {/* Editor Section */}
                  {isEditing && (
                    <div className="editor-section mt-4">
                      <h6 className="mb-3">Edit Question</h6>

                      {loadingEditorData ? (
                        <div className="text-center p-3">
                          <div className="spinner-border" role="status" />
                          <div className="mt-2">Loading editor...</div>
                        </div>
                      ) : (
                        <>
                          {/* Question Text */}
                          {editorData.p_text &&
                            <>
                              <div className="mb-3">
                                <label><strong>Paragraph Text:</strong></label>
                                <MyEditor
                                  data={editorData.p_text}
                                  handleChange={(val) =>
                                    setEditorData((prev) => ({ ...prev, p_text: val }))
                                  }
                                />
                                <button
                                  className="btn btn-primary mt-2"
                                  onClick={saveAllEdits}
                                  disabled={loading}
                                >
                                  Save Paragraph & Tags
                                </button>
                              </div>
                            </>
                          }
                          <div className="mb-3">
                            <label><strong>Question Text:</strong></label>
                            <MyEditor
                              data={editorData.q_text}
                              handleChange={(val) =>
                                setEditorData((prev) => ({ ...prev, q_text: val }))
                              }
                            />
                            <button
                              className="btn btn-primary mt-2"
                              onClick={saveAllEdits}
                              disabled={loading}
                            >
                              Save Question & Tags
                            </button>
                          </div>


                          <hr></hr>
                          {/* Integer / Subjective Answer Input */}
                          {isIntegerOrSubjective && (
                            <div className="mb-3">
                              <label><strong>Answer:</strong></label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={


                                  "Enter your answer"
                                }
                                value={editorData.subjective_answer}
                                onChange={(e) =>
                                  setEditorData((prev) => ({
                                    ...prev,
                                    subjective_answer: e.target.value,
                                  }))
                                }
                              />

                              <button
                                className="btn btn-primary mt-2"
                                onClick={submitOptions}
                                disabled={loading}
                              >
                                Save Answer
                              </button>
                            </div>
                          )}


                          {/* Options Editor */}
                          {(isSingleCorrect || isMultiCorrect) && (
                            <div className="mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <label><strong>Options:</strong></label>
                                <button
                                  className="btn btn-sm btn-secondary"
                                  onClick={addNewOptionRow}
                                >
                                  + Add Option
                                </button>
                              </div>

                              {editorData.eng_option.map((opt, i) => (
                                <div key={i} className="mb-3 option-editor">
                                  <div className="d-flex justify-content-between mb-2">
                                    <label className="mb-0">
                                      <input
                                        type={allowMultipleCorrectSelection ? "checkbox" : "radio"}
                                        name="correct_opt"
                                        checked={opt.is_correct === 1}
                                        onChange={(e) =>
                                          setOptionCorrect(i, e.target.checked)
                                        }
                                        className="mr-2"
                                      />
                                      Option {i + 1} {opt.is_correct === 1 && "(Correct)"}
                                    </label>

                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() => removeOptionRow(i)}
                                    >
                                      Remove
                                    </button>
                                  </div>

                                  <MyEditor
                                    data={opt.option || ""}
                                    handleChange={(val) =>
                                      setEditorData((prev) => {
                                        const next = [...prev.eng_option];
                                        next[i] = { ...next[i], option: val };
                                        return { ...prev, eng_option: next };
                                      })
                                    }
                                  />
                                </div>
                              ))}

                              {/* 🔥 ACTION BUTTONS – ADDED ONLY */}
                              <button
                                className="btn btn-primary mt-2"
                                onClick={submitOptions}
                                disabled={loading}
                              >
                                Save Options
                              </button>
                            </div>
                          )}

                          <hr></hr>

                          <div className="mb-3">
                            <label><strong>Solution:</strong></label>
                            <MyEditor
                              data={editorData.solution}
                              handleChange={(val) =>
                                setEditorData((prev) => ({ ...prev, solution: val }))
                              }
                            />
                            <button
                              className="btn btn-primary mt-2"
                              onClick={submitSolution}
                              disabled={loading}
                            >
                              Save Solution
                            </button>
                          </div>

                        </>
                      )}
                    </div>
                  )}


                  {/* Action Buttons */}
                  <div className="action-buttons mt-4">
                    {isEditing ? (
                      <>
                        {/* <button
                          className="btn btn-success"
                          onClick={saveAllEdits}
                          disabled={loading || loadingEditorData}
                        >
                          <i className="fa fa-save"></i> Save Changes
                        </button> */}
                        <button
                          className="btn btn-secondary"
                          onClick={handleCancelEdit}
                          disabled={loading || loadingEditorData}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="btn btn-warning"
                          onClick={() => handleEditClick(currentQuestion)}
                        >
                          <i className="fa fa-edit"></i> Edit
                        </button>
                        <button
                          className="btn btn-success"
                          onClick={() => handleKeep(currentQuestion)}
                        >
                          <i className="fa fa-check"></i> Keep
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleDiscard(currentQuestion)}
                        >
                          <i className="fa fa-trash"></i> Discard
                        </button>
                      </>
                    )}
                  </div>
                </Card>
              </div>

              {/* Duplicate Questions Section - Right Side */}
              {!isEditing && (
                <div className="col-lg-5">
                  <Card className="duplicate-questions-card">
                    <h5 className="mb-3">
                      <i className="fa fa-copy"></i> Matched Questions
                      <span className="badge badge-warning ml-2">
                        {duplicateQuestions.length}
                      </span>
                    </h5>

                    {duplicateQuestions.length === 0 ? (
                      <div className="alert alert-success">
                        {currentQuestion?.duplicacy_service === 1 ? (
                          <span className="text-success d-flex align-items-center gap-1">
                            <i className="fa fa-check-circle"></i>
                            No duplicate questions found. This question appears to be unique.
                          </span>
                        ) : (
                          <span className="text-danger d-flex align-items-center gap-1">
                            <i className="fa fa-exclamation-triangle"></i>
                            Duplicacy Service Timed Out
                          </span>
                        )}
                      </div>
                    ) : (
                      <div className="duplicates-scrollable-container">

                        {duplicateQuestions.map((dupQuestion, idx) => {

                          const isSelected = selectedMatchedQid === dupQuestion.qid;

                          return (
                            <div
                              key={idx}
                              className={`duplicate-item ${isSelected ? "border border-primary" : ""}`}
                              style={{
                                padding: "10px",
                                borderRadius: "6px",
                                marginBottom: "10px",
                                background: isSelected ? "#f0f8ff" : "#fff",
                                cursor: "pointer"
                              }}
                              onClick={() => setSelectedMatchedQid(dupQuestion.qid)}
                            >

                              {/* Header with Radio */}
                              <div className="duplicate-item-header d-flex align-items-center justify-content-between">

                                <div className="d-flex align-items-center gap-2">

                                  {/* ✅ RADIO BUTTON */}
                                  <input
                                    type="radio"
                                    name="matched_question"
                                    checked={isSelected}
                                    onChange={() => setSelectedMatchedQid(dupQuestion.qid)}
                                    style={{ marginRight: "8px" }}
                                  />

                                  <span className="badge badge-primary">
                                    QID: {dupQuestion.qid}
                                  </span>

                                  {dupQuestion.similarity && (
                                    <span className="badge badge-warning ml-2">
                                      {dupQuestion.similarity} Match
                                    </span>
                                  )}

                                  {dupQuestion.source && (
                                    <small className="text-muted ml-2">
                                      Source: {dupQuestion.source}
                                    </small>
                                  )}

                                </div>

                              </div>


                              {/* Question Content */}
                              <div className="duplicate-item-content mt-2">

                                {dupQuestion.q_text && (
                                  <div className="mb-2">
                                    <strong className="small">Question:</strong>
                                    <div
                                      className="content-text"
                                      dangerouslySetInnerHTML={{
                                        __html: dupQuestion.q_text
                                      }}
                                    />
                                  </div>
                                )}

                                {dupQuestion.eng_option && (
                                  <div className="mb-2">
                                    <strong className="small">Options:</strong>
                                    <ol className="small-options-list">
                                      {dupQuestion.eng_option
                                        .split("@@@")
                                        .map((option, i) => (
                                          <li key={i}>
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: option
                                              }}
                                            />
                                          </li>
                                        ))}
                                    </ol>
                                  </div>
                                )}

                                {dupQuestion.answer && (
                                  <div className="mb-2">
                                    <strong className="small">Answer:</strong>
                                    <span className="badge badge-success ml-2 badge-sm">
                                      {dupQuestion.answer}
                                    </span>
                                  </div>
                                )}

                                {dupQuestion.sol_text && (
                                  <div>
                                    <strong className="small">Solution:</strong>
                                    <div
                                      className="content-text small"
                                      dangerouslySetInnerHTML={{
                                        __html: dupQuestion.sol_text
                                      }}
                                    />
                                  </div>
                                )}

                              </div>

                            </div>
                          );

                        })}

                      </div>
                    )}
                  </Card>
                </div>
              )}

            </div>
          </div>
        ) : null}
      </div>
      {showReviewModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">

                <div className="modal-header bg-danger text-white">
                  <h5 className="modal-title">Review Required</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => setShowReviewModal(false)}
                  >
                    <span>&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <p>{reviewMessage}</p>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-primary"
                    onClick={handleGoToPendingQuestion}
                  >
                    Go to First Pending Question
                  </button>

                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowReviewModal(false)}
                  >
                    Close
                  </button>
                </div>

              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}

    </Graybg>
  );
};

export default ViewQuestions;